import { MANDATORY_FIELD } from '../../config/zodConfig';
import { z } from 'zod';

export const SchoolBoardFormSchema = z
  .object({
    id: z.number().optional(),
    
    name: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
      
    description: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
      
    initialDate: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
      
    validUntil: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
      
    image: z.string(),

    studentId: z.array(z.number()).optional().default([]),
    responsibleId: z.array(z.number()).optional().default([]),
    classId: z.array(z.number()).optional().default([]),
  })
  .superRefine((data, ctx) => {
    const initial = new Date(data.initialDate);
    const valid = new Date(data.validUntil);

    if (!isNaN(initial.getTime()) && !isNaN(valid.getTime())) {
      if (valid < initial) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['validUntil'],
          message: 'A data de validade não pode ser anterior à data inicial.',
        });
      } else if (valid.getTime() - initial.getTime() < 24 * 60 * 60 * 1000) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['validUntil'],
          message: 'A validade deve ser de pelo menos 1 dia após a data inicial.',
        });
      }
    }

    const hasClass = data.classId.length > 0;
    const hasStudent = data.studentId.length > 0;
    const hasResponsible = data.responsibleId.length > 0;

    if (!hasClass && !hasStudent && !hasResponsible) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['responsibleId'], 
        message: 'Selecione pelo menos um destinatário (Turma, Estudante ou Responsável).',
      });
    }
  });